angular.module('aprima-bridge', [
    //aprima
    'aprima-core',

    //third party
    'lodash']);